import { createMuiTheme } from "@material-ui/core/styles"

const custom = {
  palette: {
    primary: {
      main: "#00b1a3",
      dark: "#00a195",
      contrastText: "#fff",
    },
    secondary: {
      main: "#d93845",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: ['"Helvetica"', "sans-serif"].join(","),
  },
  overrides: {
    MuiOutlinedInput: {
      inputMarginDense: {
        fontSize: "0.875rem",
        paddingTop: "10.5px",
        paddingBottom: "10.5px",
      },
    },

    MuiInputLabel: {
      marginDense: {
        fontSize: "0.875rem",
      },
    },

    MuiTypography: {
      h1: {
        // variant for all page headers
        fontSize: "1.25rem",
        fontWeight: "bold" as const,
      },
      h2: {
        fontSize: "1.25rem",
        fontWeight: 400,
      },
      h6: {
        fontSize: "1.1rem",
        fontWeight: 500,
        color: "var(--black)",
      },
      body2: {
        color: "#808080",
        fontSize: "0.875rem",
      },
      subtitle1: {
        color: "#808080",
        fontSize: "1.1rem",
      },
      subtitle2: {
        color: "#6b6b6b",
        fontSize: "0.875rem",
        fontWeight: 300,
      },
    },

    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: "var(--white, #fff)",
        },
      },
    },
  },
}

export const theme = createMuiTheme(custom)
